import { getCountryName } from './countries';

/**
 * Single-line mailing address for tables and summaries.
 * @param {object} address
 * @param {{ includeCountry?: boolean }} options - includeCountry shows country for all regions (e.g. search field)
 */
export const formatAddressDisplay = (address = {}, { includeCountry = false } = {}) => {
  if (!address) {
    return '';
  }

  const parts = [];

  if (address.street) {
    parts.push(address.street);
  }
  if (address.addressLine2) {
    parts.push(address.addressLine2);
  }

  const locality = [address.city, address.state, address.zipCode].filter(Boolean).join(', ');
  if (locality) {
    parts.push(locality);
  }

  const countryCode = address.countryCode;
  if (countryCode && (includeCountry || countryCode !== 'US')) {
    parts.push(address.countryName || getCountryName(countryCode));
  }

  return parts.join(', ');
};
